import React, { useState, useEffect, useCallback } from "react";
import { BASE_URL } from "../../Utils/api";
import { Modal, Button } from "react-bootstrap";
import "./NovidadesVersaoModal.css";


function ConteudoVersao({ texto }) {
  if (!texto) return null;

  const linhas = texto.split("\n");
  const elementos = [];
  let key = 0;

  for (const linha of linhas) {
    const trimmed = linha.trim();

    if (trimmed.startsWith("## ")) {
      elementos.push(
        <div key={key++} style={{ marginTop: "1rem", marginBottom: "0.35rem" }}>
          <span
            style={{
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "var(--bs-secondary-color)",
              borderBottom: "1px solid var(--bs-border-color)",
              display: "block",
              paddingBottom: "0.2rem",
            }}
          >
            {trimmed.slice(3)}
          </span>
        </div>
      );
    } else if (trimmed.startsWith("• ")) {
      elementos.push(
        <div
          key={key++}
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "0.5rem",
            fontSize: "0.855rem",
            color: "var(--bs-body-color)",
            padding: "0.18rem 0",
          }}
        >
          <span style={{ color: "#0d6efd", fontWeight: 700, lineHeight: 1.4, flexShrink: 0 }}>•</span>
          <span style={{ lineHeight: 1.5 }}>{trimmed.slice(2)}</span>
        </div>
      );
    } else if (trimmed === "") {
      elementos.push(<div key={key++} style={{ height: "0.3rem" }} />);
    } else {
      elementos.push(
        <p key={key++} style={{ fontSize: "0.855rem", color: "var(--bs-body-color)", margin: "0.25rem 0" }}>
          {trimmed}
        </p>
      );
    }
  }

  return <div>{elementos}</div>;
}

function NovidadesVersaoModal({ show, novidadesVersao = [], onClose }) {
  const lista = Array.isArray(novidadesVersao) ? novidadesVersao : [];
  const [indice, setIndice] = useState(0);

  // Reinicia no início ao abrir
  useEffect(() => {
    if (show) setIndice(0);
  }, [show]);

  const marcarVisualizada = useCallback((id) => {
    const token = localStorage.getItem("authToken");
    if (!token || !id) return;
    fetch(`${BASE_URL}/api/versoes/visualizar`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ id_versao: id }),
    }).catch(() => {});
  }, []);

  const handleProxima = () => {
    marcarVisualizada(lista[indice]?.id);
    setIndice((i) => i + 1);
  };

  const handleEntendi = () => {
    marcarVisualizada(lista[indice]?.id);
    onClose();
  };

  if (lista.length === 0) {
    return (
      <Modal
        show={show}
        onHide={onClose}
        centered
        dialogClassName="novidades-versao-dialog"
        contentClassName="novidades-versao-content"
      >
        <Modal.Header closeButton>
          <Modal.Title>Novidades de Versão</Modal.Title>
        </Modal.Header>
        <Modal.Body className="novidades-versao-body d-flex align-items-center justify-content-center">
          <p className="text-muted text-center" style={{ fontSize: "0.9rem" }}>
            Nenhuma versão disponível no momento.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={onClose}>Fechar</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const versaoAtual = lista[indice];
  const isUltima    = indice === lista.length - 1;
  const total       = lista.length;

  return (
    <Modal
      show={show}
      onHide={handleEntendi}
      centered
      backdrop="static"
      dialogClassName="novidades-versao-dialog"
      contentClassName="novidades-versao-content"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ display: "flex", alignItems: "center", gap: 10 }}>
          Novidades de Versão
          {total > 1 && (
            <span
              style={{
                fontSize: "0.75rem",
                fontWeight: 400,
                color: "var(--bs-secondary-color)",
                background: "var(--bs-secondary-bg)",
                borderRadius: 20,
                padding: "2px 10px",
              }}
            >
              {indice + 1} de {total}
            </span>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="novidades-versao-body">
        {/* Cabeçalho da versão atual */}
        <div className="d-flex align-items-center gap-2 mb-3">
          <span
            className="badge"
            style={{
              background: "linear-gradient(135deg, #0d6efd, #0a58ca)",
              fontSize: "0.82rem",
              padding: "0.35em 0.75em",
            }}
          >
            v{versaoAtual.versao}
          </span>
          {versaoAtual.data_liberacao && (
            <small className="text-muted">
              {new Date(versaoAtual.data_liberacao).toLocaleDateString("pt-BR")}
            </small>
          )}
          {versaoAtual.titulo && (
            <span style={{ fontWeight: 600, fontSize: "0.95rem", color: "var(--bs-body-color)" }}>
              {versaoAtual.titulo}
            </span>
          )}
        </div>

        <ConteudoVersao texto={versaoAtual.conteudo} />
      </Modal.Body>

      <Modal.Footer className="modal-footer-padrao">
        {/* Indicadores de ponto */}
        <div className="modal-footer-acoes-esquerda" style={{ display: "flex", gap: 6, alignItems: "center" }}>
          {total > 1 && lista.map((_, i) => (
            <span
              key={i}
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: i === indice ? "#0d6efd" : "var(--bs-border-color)",
                display: "inline-block",
                transition: "background 0.2s",
              }}
            />
          ))}
        </div>

        <div className="modal-footer-acoes-direita" style={{ display: "flex", gap: 8 }}>
          {indice > 0 && (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setIndice((i) => i - 1)}
              style={{ fontSize: "0.85rem" }}
            >
              ← Anterior
            </Button>
          )}
          {!isUltima ? (
            <Button
              variant="primary"
              className="modal-footer-btn-salvar"
              onClick={handleProxima}
            >
              Próxima →
            </Button>
          ) : (
            <Button
              variant="success"
              className="modal-footer-btn-salvar"
              onClick={handleEntendi}
            >
              Entendi
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default NovidadesVersaoModal;
